import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class ChorusEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chorusEffect: props.chorusEffect,
        };
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.chorusEffect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.chorusEffect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Rate'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.chorusEffect.rateParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        isParameter={true}
                        step={0.01}
                        max={12}
                        min={0}
                        />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Depth'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.chorusEffect.depthParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        isParameter={true}
                        step={0.1}
                        max={3}
                        min={0}
                        />
                      <WetSlider
                            effectNumber={this.props.effectNumber}
                            sequencerEngine={this.props.sequencerEngine}
                            automation={this.props.automation}
                            selectedParameter={this.props.selectedParameter}
                            onParameterChanged={this.props.onParameterChanged}
                            effect={this.state.chorusEffect}/>
                 </div>} 
            </div>
        );
    }
}

export default ChorusEffect;
